module.exports = __webpack_public_path__ + "static/media/so.5d09b7df.svg";